// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"17978bf4","239":"81352cb2","455":"b9e58146","970":"a16ac8e0"}[chunkId] + ".chunk.js";
};